import {Types} from "@Common/types";

import {changeNestedValue, getNestedValue, setNestedValue} from "../utils/arr-path";

/**
 * Create a 'scoped-state' object from a given state component.
 * This 'scoped-state' will be given by and will edit some inner value of the state.
 * This inner value is chosen by the 'path' parameter.
 */
export const scopedState = <T extends Record<any, any>, TPath extends Types.Common.Utils.ArrPath.PathParam<T>>(
    state : Types.Common.React.UseState.UseStateNext<T>,
    path  : TPath,
) => ({
    value: getNestedValue(state.value, path),
    onChange: (value:Types.Common.Utils.ArrPath.PathType<T, TPath>, cb = undefined) => {
        if (state.change) {
            return state.change((s1) => setNestedValue(s1, path, value), cb);
        } else {
            return state.onChange(setNestedValue(state.value, path, value), cb);
        }
    },
    change: (reduce:(oldValue:Types.Common.Utils.ArrPath.PathType<T, TPath>) => Types.Common.Utils.ArrPath.PathType<T, TPath>, cb = undefined) => {
        if (state.change) {
            return state.change(
                (v) => changeNestedValue(v, path, reduce),
                cb,
            );
        } else {
            return state.onChange(changeNestedValue(state.value, path, reduce), cb);
        }
    },
});

